import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';

const DropItemOverlay = ({ isOver, canDrop, reordering }) => {
  const intl = useIntl();

  if (!(isOver && canDrop) || reordering) {
    return null;
  }

  return (
    <div className="drop-overlay">
      <h5>{intl.formatMessage({ defaultMessage: 'Drop here to move' })}</h5>
      <i className="far fa-arrow-alt-right fa-xl" />
    </div>
  );
};

DropItemOverlay.propTypes = {
  isOver: PropTypes.bool.isRequired,
  canDrop: PropTypes.bool.isRequired,
  reordering: PropTypes.bool.isRequired,
};

export default DropItemOverlay;
